import {
  GET_COURSES_LOADING,
  GET_COURSES_SUCCESS,
  GET_COURSES_ERROR,
  CREATE_COURSES_ERROR,
  CREATE_COURSES_LOADING,
  CREATE_COURSES_SUCCESS,
  DELETE_COURSES_LOADING,
  DELETE_COURSES_ERROR,
  DELETE_COURSES_SUCCESS,
  EDIT_COURSES_LOADING,
  EDIT_COURSES_SUCCESS,
  EDIT_COURSES_ERROR,
  VIEW_COURSE_LOADING,
  VIEW_COURSE_SUCCESS,
  VIEW_COURSE_ERROR,
  GET_MIN_COURSES_LOADING,
  GET_MIN_COURSES_SUCCESS,
  GET_MIN_COURSES_ERROR,
} from "../../../constant/actionTypes";
import { apiDelete, apiGet, apiPut } from "../../../utils/apiRequests";
import ApiEndpoints from "../../../utils/ApiEndpoints";
import { toast } from "react-toastify";

const BASE_URL = ApiEndpoints.course.base;
export const getAllCourses =
  (page = 1, limit = 10) =>
  (dispatch) => {
    dispatch({ type: GET_COURSES_LOADING });
    apiGet(
      `${BASE_URL}?page=${page}&limit=${limit}`,
      (response) => {
        // console.log("get courses response ==============> ", response);
        if (response.error == true) {
          dispatch({ type: GET_COURSES_ERROR, response: response.message });
        } else {
          dispatch({ type: GET_COURSES_SUCCESS, response: response });
        }
      },
      (error) => {
        // console.log("error ===>>>>", error);
        dispatch({ type: GET_COURSES_ERROR, response: error });
      }
    );
  };

export const viewCourseDetails = (id) => (dispatch) => {
  dispatch({ type: VIEW_COURSE_LOADING });
  apiGet(
    `${BASE_URL}${ApiEndpoints.course.view}${id}`,
    (response) => {
      // console.log("view course details response ==============> ", response);
      if (response.error == true) {
        dispatch({ type: VIEW_COURSE_ERROR, response: response.message });
      } else {
        dispatch({ type: VIEW_COURSE_SUCCESS, response: response });
      }
    },
    (error) => {
      // console.log("error ===>>>>", error);
      dispatch({ type: VIEW_COURSE_ERROR, response: error });
    }
  );
};

export const createCourse = (data) => (dispatch) => {
  dispatch({ type: CREATE_COURSES_LOADING });
  apiPut(
    `${BASE_URL}${ApiEndpoints.course.add}`,
    data,
    (response) => {
      // console.log("submit course response ....", response);

      if (response.error == true) {
        dispatch({ type: CREATE_COURSES_ERROR, response: response.message });
      } else {
        dispatch({ type: CREATE_COURSES_SUCCESS, response: response });
      }
    },
    (error) => {
      // console.log("error ===>>>>", error);
      dispatch({ type: CREATE_COURSES_ERROR, response: error });
    }
  );
};

export const deleteCourse = (id) => (dispatch) => {
  dispatch({ type: DELETE_COURSES_LOADING });
  apiDelete(
    `${BASE_URL}${ApiEndpoints.course.delete}${id}`,
    (response) => {
      // console.log("delete course response ....", response);

      if (response.error == true) {
        dispatch({ type: DELETE_COURSES_ERROR, response: response.message });
      } else {
        dispatch({ type: DELETE_COURSES_SUCCESS, response: response });
      }
    },
    (error) => {
      // console.log("error ===>>>>", error);
      dispatch({ type: DELETE_COURSES_ERROR, response: error });
    }
  );
};

export const editCourse = (id, data, navigate) => (dispatch) => {
  dispatch({ type: EDIT_COURSES_LOADING });
  apiPut(
    `${BASE_URL}${ApiEndpoints.course.update}${id}`,
    data,
    (response) => {
      if (response.error == true) {
        dispatch({ type: EDIT_COURSES_ERROR, response: response.message });
      } else {
        dispatch({ type: EDIT_COURSES_SUCCESS, response: response });
        toast.success("Course updated");
        navigate("/courses");
      }
    },
    (error) => {
      dispatch({ type: EDIT_COURSES_ERROR, response: error });
    }
  );
};

export const getMinimalCourseList = () => (dispatch) => {
  dispatch({ type: GET_MIN_COURSES_LOADING });
  apiGet(
    `${BASE_URL}${ApiEndpoints.course.courseList}`,
    (response) => {
      if (response.error === true) {
        dispatch({ type: GET_MIN_COURSES_ERROR, response: response.message });
      } else {
        dispatch({ type: GET_MIN_COURSES_SUCCESS, response: response });
      }
    },
    (error) => {
      // console.log("error ===>>>>", error);
      dispatch({ type: GET_MIN_COURSES_ERROR, response: error });
    }
  );
};
